import type { Translation } from '@/ui-kit/localization/locales/types';

const fiFI: Translation = {
  loading: 'Ladataan',
  progressBarCompleted: 'Valmis',
  progressBarCurrent: 'Nykyinen',
};

export default fiFI;
